import logo from "../../assets/IOZ_LOGO_weiss.png";
import "./Logo.css";

function Logo() {
  return (
    <>
      <img src={logo} alt="IOZ Logo" className="logo"></img>
    </>
  );
}

export default Logo;
